import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Card } from '../SubscriptionAppCard';
import { TagInput } from '../TagInput';
import type { TagData } from '../TagInput';
import { NoteInput } from '../subscription-detail/NoteInput';
import { TimelineEvent } from '../subscription-detail/TimelineEvent';
interface PanelNote {
  id: string | number;
  title: string;
  description: string;
  date: string;
  author?: string;
}
interface ContactSidePanelProps {
  notes: PanelNote[];
  onAddNote: (note: string) => void;
  appTags: TagData[];
  availableTags: TagData[];
  onAddTag: (tag: TagData) => void;
  onRemoveTag: (tagId: string) => void;
  onCreateTag: (label: string, color?: string) => void;
  shopifyTags: string[];
}
const MAX_NOTES = 5;

// Notes and tags kept beside every tab, so they're always to hand on a call
export function ContactSidePanel({
  notes,
  onAddNote,
  appTags,
  availableTags,
  onAddTag,
  onRemoveTag,
  onCreateTag,
  shopifyTags
}: ContactSidePanelProps) {
  const latestNotes = notes.slice(0, MAX_NOTES);
  return <aside className="space-y-6 xl:sticky xl:top-6" aria-label="Notes and tags" data-id="element-1498" data-mp="265yws9on3set">
      <Card padding="none" data-id="element-1499" data-mp="2b278fd3mp3h8">
        <div className="px-5 py-4 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-1500" data-mp="1we2oy6wr4nxe">
          <h2 className="text-[16px] font-semibold text-[#0F172A]" data-id="element-1501" data-mp="21d5tlq8tks4u">Notes</h2>
        </div>
        <div className="p-5 border-b border-[#E2E8F0] bg-[#F8FAFC]" data-id="element-1502" data-mp="21at66xkalpke">
          <NoteInput onSubmit={onAddNote} data-id="element-1503" data-mp="1nbthxr0ozcor" />
        </div>
        <div className="p-5 bg-white rounded-b-lg max-h-[360px] overflow-y-auto" data-id="element-1504" data-mp="1sd0ojmr3m5tu">
          {latestNotes.length === 0 ? <p className="text-sm text-[#94A3B8]" data-id="element-1505" data-mp="1dg01vxnrl128">
              No notes yet.
            </p> : <ol className="list-none" role="list" aria-label="Latest notes" data-id="element-1506" data-mp="1idrxb1nmb5b6">
              {latestNotes.map((note, index) => <TimelineEvent key={note.id} title={note.title} description={note.description} date={note.date} author={note.author} icon={MessageSquare} iconColor="#64748B" isLast={index === latestNotes.length - 1} eventType="note" data-id="element-1507" data-mp="37szo49mngtih" data-mpi={index} />)}
            </ol>}
        </div>
      </Card>

      <Card padding="none" data-id="element-1508" data-mp="36cc4jp1qh76o">
        <div className="px-5 py-4 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-1509" data-mp="36b11xsk0y5h5">
          <h2 className="text-[16px] font-semibold text-[#0F172A]" data-id="element-1510" data-mp="31dr53rub2rja">Tags</h2>
        </div>
        <div className="p-5 bg-white rounded-b-lg space-y-4" data-id="element-1511" data-mp="2xcfogbtetgn8">
          <div data-id="element-1512" data-mp="3u1n9zju13pr5">
            <label className="block text-sm font-medium text-[#475569] mb-2" data-id="element-1513" data-mp="3u26iyb1pb3t1">
              App Tags
            </label>
            <TagInput tags={appTags} availableTags={availableTags} onAddTag={onAddTag} onRemoveTag={onRemoveTag} onCreateTag={onCreateTag} placeholder="Add or create tag..." data-id="element-1514" data-mp="3p3licaijei42" />
          </div>
          <div data-id="element-1515" data-mp="3gb1pjqoxf7r5">
            <label className="block text-sm font-medium text-[#475569] mb-2" data-id="element-1516" data-mp="3g9gwy6m69yvx">
              Shopify Tags
            </label>
            <div className="flex flex-wrap gap-2" data-id="element-1517" data-mp="gov22u7f4lfl">
              {shopifyTags.map(tag => <span key={tag} className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-[#F1F5F9] text-[#475569] border border-[#E2E8F0]" data-id="element-1518" data-mp="bv8omztfkdiq">
                  {tag}
                </span>)}
            </div>
            <p className="text-xs text-[#94A3B8] mt-2" data-id="element-1519" data-mp="1zjz8vt0n4ysp">Synced from Shopify</p>
          </div>
        </div>
      </Card>
    </aside>;
}